module.exports = __webpack_public_path__ + "static/media/GoogleSans-Medium.8c566961.ttf";